import React, { useState, useEffect } from 'react';
import Header from "./Header"

function FreeChips( data ) {

  return (
    <div className="freeChipsMainHolder">
      <Header headerContext='freeChips'
      user={ data.user }
      logout={ data.logout }
      toggleGetChips={ data.toggleGetChips }
      width = { data.width }
      showSiteMenu = { data.showSiteMenu }
      toggleSiteMenu = { data.toggleSiteMenu }/>
      <div className='handsTableHolder'>
        <h2 className='pokerHandsTitle'>Just start and get free chips for playing!</h2>
        <p>Once you log in, you'll receive a one-time sign-up bonus. Plus, explore our chip store to discover several ways to earn free chips</p>
        <div className='FreeChipsBannerDailyHolder'>
          <img className='freeChips' src={ './images/freeChips_signup.svg' }></img>
          <img className='freeChips' src={ './images/freeChips_hourly.svg' }></img>
          <img className='freeChips' src={ './images/freeChips_daily.svg' }></img>
          {/* <img className='freeChips' src={ './images/freeChips_promocode.svg' }></img> */}
        </div>
      </div>
    </div>
  )
}

export default FreeChips;